module.exports = __webpack_public_path__ + "static/media/icon-pen@2x.c49799d8.svg";